module.exports = "/assets/coca-cola-zero.jpg?/oP19sT";